import script from "./BirthReveal.vue?vue&type=script&setup=true&lang=js"
export * from "./BirthReveal.vue?vue&type=script&setup=true&lang=js"

import "./BirthReveal.vue?vue&type=style&index=0&id=06d696d4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06d696d4"]])

export default __exports__